import { apiFetch } from './api';

/**
 * Public Categories API
 */

export interface HomeCategory {
    id: string;
    name: string;
    description: string | null;
    showOnHome: boolean;
    icon: string | null;
    createdAt: string;
    updatedAt: string;
}

export const categoriesAPI = {
    /**
     * Get categories marked to show on home page
     */
    getHomeCategories: async (): Promise<{ success: boolean; categories: HomeCategory[] }> => {
        const response = await apiFetch<{ success: boolean; categories: HomeCategory[] }>('/categories/home');
        return response;
    }
};
